import styled from 'styled-components';
import Select from '@ertelecom/ui-react/components/select/select';

export const Container = styled.div`
    margin: 0 auto;
    width: 100%;
    max-width: 1360px;
    flex-direction: column;
    @media (max-width: 860px) {
        padding: 0 30px;
        margin-top: 90px;
    }
    @media (max-width: 460px) {
        padding: 0 10px;
    }
`;

export const Header = styled.h1`
    font-size: 44px;
    margin-top: 50px;
    margin-bottom: 20px;
    height: 80px;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    @media (max-width: 768px) {
        font-size: 44px;
    }
`;

export const SelectStyled = styled(Select)`
    width: 350px;
    margin-bottom: 20px;
    @media (max-width: 460px) {
        width: 100%;
    }
`;

export const PromoLoading = styled.div`
    width: 100%;
    padding: 20px 0;
`;

export const SubHeader = styled.p`
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    font-size: 24px;
    margin-bottom: 20px;
    max-height: 100px;
`;

export const Card = styled.div`
    flex-direction: row;
    max-width: 33%;
    margin-bottom: -30px;
    min-width: 315px;
    @media (max-width: 1185px) {
        max-width: 50%;
    }
    @media (max-width: 706px) {
        max-width: 100%;
    }
`;

export const CardWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    height: fit-content;
`;
